import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { formatCurrency } from '../../../shared/utils';
import { policyChangeRadioButtonStyle } from './policy-change-radio-button-label-style';

function PolicyChangeRadioButtonLabel(props) {
  const classes = policyChangeRadioButtonStyle();

  const {
    raw_rate = 0,
    annual_limit = '0',
    current = false,
    capped_rate = null,
  } = props;

  const annualLimit = formatCurrency(parseInt(annual_limit) / 1000, {
    areCents: false,
    hideZero: true,
    ifNaN: 'Unlimited',
  });

  return (
    <div className={classes.radioButtonLabelContainer}>
      <div className={classes.rawRateContainer}>
        <Typography className={classes.rawRate}>
          {formatCurrency(raw_rate, { areCents: false })}
        </Typography>

        {capped_rate ? (
          <span
            className={classes.cappedRate}
            title={`Capped Rate: ${formatCurrency(capped_rate)}`}
            data-testid='capped-rate-asterisk'
          >
            *
          </span>
        ) : null}

        {current ? (
          <span className={classes.currentPolicyChip}>Current Policy</span>
        ) : null}
      </div>
      <Typography className={classes.deductible}>
        {`${
          annualLimit === 'Unlimited' ? annualLimit : annualLimit + 'K'
        } Annual Limit`}
      </Typography>
    </div>
  );
}

PolicyChangeRadioButtonLabel.propTypes = {
  raw_rate: PropTypes.number,
  annual_limit: PropTypes.string,
  current: PropTypes.bool,
  capped_rate: PropTypes.number,
};

export default PolicyChangeRadioButtonLabel;
